module.exports = __webpack_public_path__ + "static/media/Kiet_logo.fd08b5de.png";